import React from "react";
import { Link } from "react-router-dom";

import unityOrbit from "../../images/unity-dark-orbit.svg";
import unityDevices from "../../images/unity-device-composite.webp";
import "./UnityLearningSection.css";

function ArrowRight() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M5 12h14" />
      <path d="m13 6 6 6-6 6" />
    </svg>
  );
}

export default function UnityLearningSection() {
  return (
    <section
      id="unity-learning"
      className="unity-learning"
      aria-labelledby="unity-learning-title"
    >
      <div
        className="unity-learning__glow"
        aria-hidden="true"
      />

      <div className="unity-learning__inner">
        <div className="unity-learning__visual">
          <img
            className="unity-learning__orbit"
            src={unityOrbit}
            alt=""
            aria-hidden="true"
          />

          <img
            className="unity-learning__devices"
            src={unityDevices}
            alt="Unity Learning displayed on tablet and mobile devices"
            loading="lazy"
            decoding="async"
          />

          <div
            className="unity-learning__visual-label"
            aria-hidden="true"
          >
            <span />

            <p>
              AI-driven learning
              <br />
              operating system
            </p>
          </div>
        </div>

        <div className="unity-learning__copy">
          <p className="unity-learning__eyebrow">
            Unity Learning
          </p>

          <h2 id="unity-learning-title">
            <span>Learning that</span>
            <span>adapts before</span>
            <span>learners fall behind.</span>
          </h2>

          <p className="unity-learning__body">
            Unity turns source knowledge into structured
            programmes, adapts learning at concept level,
            and gives facilitators the insight to act early.
          </p>

          <Link
            className="unity-learning__cta"
            to="/unity-learning"
          >
            <span>Explore Unity Learning</span>
            <ArrowRight />
          </Link>
        </div>
      </div>
    </section>
  );
}
